module.exports = __webpack_public_path__ + "img/default-nav-subnav-infiniti.e8f9372e.png";